import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import ValidSignLogo from '@ValidSignBV/theme-switcher/logos/validsign-black-orange.svg?react';
import {DASHBOARD_PATH} from '../../../../constants';
import {selectAccount} from '../../Login/userSlice';
import {selectBrand} from '../../AdminPanel/ThemesAndStyles/brandSettingsSlice';
import {selectDefaultBrand} from '../../SignerUi/signerUiSlice';
import './logo.less';

export default function Logo({isRedirectDisabled = false, isSignerUI = false, ...props}) {
    const intl = useIntl();
    const {logoUrl} = useSelector(selectAccount) || {};
    const senderBrand = useSelector(selectBrand);
    const signerBrand = useSelector(selectDefaultBrand);
    const brand = isSignerUI ? signerBrand : senderBrand;
    const brandSigningLogoUrl = brand?.signing_logo?.content;
    const logoSrc = brandSigningLogoUrl || logoUrl;

    const altText = intl.formatMessage({id: 'esl.branding.default_alt_text', defaultMessage: ''});
    const ariaLabel = intl.formatMessage({id: 'esl.header.logo.goto', defaultMessage: ''});

    const logoNode = logoSrc ? (
        <img
            src={logoSrc}
            alt={altText}
            aria-label={ariaLabel}
            height="68"
            className="default-logo-img"
            {...props}
        />
    ) : (
        <ValidSignLogo
            className="default-logo-img"
            viewBox="25 133 565 160"
            aria-label={ariaLabel}
            title={altText}
            {...props}
        />
    );

    if (isRedirectDisabled) {
        return <div className="logo">{logoNode}</div>;
    }

    return (
        <Link className="logo" to={DASHBOARD_PATH}>
            {logoNode}
        </Link>
    );
}
